import { apiSlice } from './apiSlice';
import { setIsNigerian } from '../slices/authSlice';

/**
 * KYCAID identity check for Nigerian users (KYC Verification tab).
 *
 *   GET /kycaid/get/is-nigeria/ → { is_nigeria: boolean } (or is_nigerian)
 *   GET /kycaid/get/form-url/   → { form_url: string }
 *   GET /kycaid/get/decision/   → { review_status: "pending" | ..., is_verified: boolean }
 *
 * KYCAID is the KYC provider used for Nigerian users. Everyone else uses Veriff.
 */
export const kycaidApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getIsNigeria: builder.query({
      query: () => '/kycaid/get/is-nigeria/',
      transformResponse: (response) => Boolean(response?.is_nigeria ?? response?.is_nigerian),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setIsNigerian(data));
        } catch {
          // ignore
        }
      },
      providesTags: ['Kyc'],
    }),

    getKycaidDecision: builder.query({
      query: () => '/kycaid/get/decision/',
      providesTags: ['Kyc'],
    }),

    getKycaidFormUrl: builder.query({
      query: () => '/kycaid/get/form-url/',
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useGetIsNigeriaQuery,
  useGetKycaidDecisionQuery,
  useLazyGetKycaidFormUrlQuery,
} = kycaidApi;
